<template>
  <div v-if="type==4" class="page_a">
    <div class="plate-one">
      <div class="plate-one-logo">
        <img src="@/assets/logo.png" alt="">
      </div>
    </div>
    <div class="plate-two">
      <div class="plate-two-title">
        <img :src="title1" alt="">
      </div>
    </div>
    <div class="plate-four">
      <div class="plate-four-item" v-for="(item, key) in liveList[0]" :key="key" @click="handlePlay(item.src)">
        <div class="plate-four-item-kv">
          <img :src="item.poster" alt="">
        </div>
        <div class="plate-four-item-desc">{{item.text}}</div>
      </div>
    </div>
    <div class="plate-five">
      <router-link to="/">
        <img src="@/assets/go-home.png" alt="">
      </router-link>
    </div>
    <div class="popup" v-show="isShow" @click.stop="">
      <div class="popup-close" @click="close">
        <van-icon class="popup-close-icon" name="cross"></van-icon>
      </div>
      <div class="popup-video">
        <player-video ref="video"></player-video>
      </div>
      <div class="popup-close" style="opacity: 0;">
        <van-icon name="cross"></van-icon>
      </div>
    </div>
  </div>
  <div class="page_b" v-else>
    <img src="@/assets/bj2.jpg" alt="">
    <div style="position: absolute;width: 100%;height: 100%;top: 0;left: 0;display: flex;flex-direction: column;">
      <div class="plate-one">
        <div class="plate-one-logo">
          <img src="@/assets/logo.png" alt="">
        </div>
      </div>
      <div class="plate-two">
        <div class="plate-two-title">
          <img :src="title2" alt="">
        </div>
      </div>
      <div class="plate-three">
        <a class="plate-three-item" v-for="(item, key) in liveList[1]" :key="key" :href="item.href"></a>
      </div>
      <div class="plate-five">
      <router-link to="/" replace>
        <img src="@/assets/go-home.png" alt="">
      </router-link>
    </div>
    </div>
  </div>
</template>

<script>
import PlayerVideo from '@/components/video/index'
export default {
  components: { PlayerVideo },
  data() {
    return {
      type: null,
      isShow: false,
      title1: require('@/assets/title5.png'),
      title2: require('@/assets/title6.png'),
      K: {
        href: '',
        text: ''
      },
      liveList: [[
        {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/3e2f9511/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_0feddfedaf92407a852d1fdc0220c841.jpg',
          text: '不畏台风的无人机“战士”'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/12/56145d6f/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_973671fede084b6d8bd3ca7d163d25a8.png',
          text: '动画长廊'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/12/5c199ac5/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_22585e4892fb43aa83036db42b610a8a.png',
          text: '有趣的呼吸'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/92081ad5/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_565b1fe3c66948528e2a26e3949c202f.jpg',
          text: '浓烟逃生实训体验'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/6a50ee93/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_64ad82ae4d7a413b84024adbc6f35638.jpg',
          text: '知“食”学堂-控糖'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/01d6eb8d/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_89e1ab8860d9499c88c18f19dd9ede8b.jpg',
          text: '走近蚊子'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/a48b4304/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_9cdd319673604bd288a96807e21cb2cb.jpg',
          text: '核事知多少'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/a12faab7/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_1b08b4f64ca14d5c8b060cb791bc8d0b.jpg',
          text: '植物防卫的艺术'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/5f8357ea/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_85ce0e3fb3c2408a88b34c00b488cbd6.jpg',
          text: '北极也有企鹅吗？'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/12/0746cde8/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_e15c48f9854a422d8cb9b98427e660fa.png',
          text: '空间LED照明系统'
        }
      ], [
        {
          href: 'https://afr.h5.xeknow.com/s/46gwOv',
          text: '带着孩子学科学'
        }, {
          href: 'https://afr.h5.xeknow.com/s/4B0YQu',
          text: '天文探秘（第一册）'
        }, {
          href: 'https://afr.h5.xeknow.com/s/20lazv',
          text: '天文探秘（第二册）'
        }, {
          href: 'https://afr.h5.xeknow.com/s/1ABEJI',
          text: '物质的魔变（第一册）'
        }, {
          href: 'https://afr.h5.xeknow.com/s/MSj8z',
          text: '物质的魔变（第二册）'
        }, {
          href: 'https://afr.h5.xeknow.com/s/4bSimU',
          text: '车辆模型设计与制作电子书'
        }, {
          href: 'https://afr.h5.xeknow.com/s/3vtJ3Q',
          text: '船舶模型设计与制作电子书'
        }, {
          href: 'https://afr.h5.xeknow.com/s/49J1yY',
          text: '航空模型设计与制作电子书'
        }, {
          href: 'https://afr.h5.xeknow.com/s/2G6dSo',
          text: '青少年电子制作与应用第1册'
        }, {
          href: 'https://afr.h5.xeknow.com/s/nyde4',
          text: '青少年电子制作与应用第2册'
        }
      ]]
    }
  },
  watch: {
    // isShow(n) {
    //   if (n) {
    //     document.body.style.overflowY = 'hidden';
    //   } else {
    //     document.body.style.overflowY = '';
    //   }
    // }
  },
  mounted() {
    this.type = Number(this.$route.query.type)
  },
  methods: {
    close() {
      this.isShow = false
      this.$refs.video.pause()
    },
    handlePlay(src) {
      this.isShow = true
      this.$refs.video.play(src)
    }
  }
}
</script>

<style lang="scss" scoped>
  $all-width: 96%;
  .page_a {
    width: 100%;
    height: 100%;
    background: url(~@/assets/bg3.jpg) no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    img {
      width: 100%;
    }
    .plate-four {
      flex-shrink: 1;
      flex-grow: 1;
      width: 3.6rem;
      margin: 0 auto;
      margin-top: .2rem;
      overflow-y: scroll;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: space-between;
      &-item {
        margin-bottom: .15rem;
        width: 48%;
        flex-shrink: 0;
        img {
          height: .969rem;
        }
        box-shadow: 3px 3px 5px rgb(41, 41, 41);
        &-desc {
          font-size: .13rem;
          background-color: #fff;
          line-height: .2rem;
          padding: 0 .06rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .popup {
      background-color: rgba($color: #000000, $alpha: .4);
      width: 100%;
      height: 100%;
      position: fixed;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      top: 0;
      left: 0;
      z-index: 9999;
      &-close {
        color: #fff;
        font-size: .3rem;
        text-align: right;
        padding: 1.6rem .15rem 0 0;
      }
      &-video {
        width: 100%;
        height: 2.11rem;
      }
    }
  }
  .page_b {
    position: relative;
    display: flex;
    flex-direction: column;
    img {
      width: 100%;
    }
    .plate-three {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 3.06rem;
      height: 11.1rem;
      margin: auto;
      margin-top: .15rem;
      align-content: space-between;
      &-item {
        width: 1.4rem;
        height: 2.04rem;
      }
    }
    .plate-five {
      flex-grow: 1;
    }
  }
  .plate-five {
    width: 25%;
    padding: .2rem 0;
    margin: 0 auto;
    animation-name: btn;
    animation-duration: 1.5s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
  }
  @keyframes btn {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: .4;
      transform: scale(.9);
    }
  }
</style>
